import React from "react";
import NewEventForm from "../../components/events_elements/new_events/NewEventForm";

const NewEventPage = () => {
  return <NewEventForm />;
};

export default NewEventPage;
